import React from "react";
import { Route } from "react-router";

const PropsRoute = ({ component: C, props: cProps, ...rest }) =>
  <Route {...rest} render={props => <C {...props} {...cProps} />} />;

export default PropsRoute;
